import { EgretLoadable } from "egret";

const userManagment = EgretLoadable({
  loader: () => import("./UserManagment")
});

const userManagmentRoutes = [
  {
    path: "/agentUserManagement",
    component: userManagment
  }
];

export default userManagmentRoutes;
